import { Icon } from '@toggle/design-system';
import { TFunction } from 'i18next';
import React, { FC } from 'react';

import * as S from './MobileSearchButton.styles';

interface MobileSearchButtonProps {
  isInHeader: boolean;
  openSearch: () => void;
  t: TFunction;
}

export const MobileSearchButton: FC<MobileSearchButtonProps> = ({
  isInHeader,
  openSearch,
  t,
}) =>
  isInHeader ? (
    <S.HeaderButton
      onClick={openSearch}
      data-testid="header-search-button"
      aria-label="Search"
    >
      <Icon iconName="Search" size={18} />
    </S.HeaderButton>
  ) : (
    <S.SearchButton
      onClick={openSearch}
      data-testid="mobile-search-button"
      aria-label="Search"
    >
      <Icon iconName="Search" size={22} />
      <span>{t('searchPlaceholder')}</span>
    </S.SearchButton>
  );
